const { REPUTATION_PLUS_ACTIONS } = require('./constants');

const reputationPlusPermissions = (
  action,
  permissions,
  institutionId,
  year,
) => {
  if (action === 'reputation_plus:viewProduct' &&
    permissions[institutionId].some(item => item.includes('REPUTATION_PLUS'))
  ) {
    return true;
  }

  if (
    REPUTATION_PLUS_ACTIONS.some((reputationPlusAction) =>
      action.includes(reputationPlusAction),
    ) &&
    permissions[institutionId].includes(`REPUTATION_PLUS_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  reputationPlusPermissions,
};
